class ExtensibleFunction extends Function {
  constructor(f) {
    return Object.setPrototypeOf(f, new.target.prototype);
  }
}

class ActivationFunction extends ExtensibleFunction {
  constructor(f, f_prime, name) {
      super(f)

      // derivative
      this.d = f_prime

      this.fname = name
  }
}

// relu
function relu_func(z) {
  return z > 0 ? z : 0
}

function relu_prime(z) {
  return z > 0 ? 1 : 0
}

const relu = new ActivationFunction(relu_func, relu_prime, 'relu')

// sigmoid
function sigmoid_func(z) {
  return 1 / (1 + Math.exp(-z))
}

function sigmoid_prime(z) {
  return sigmoid(z) * (1 - sigmoid(z))
}

const sigmoid = new ActivationFunction(sigmoid_func, sigmoid_prime, 'sigmoid')

const activationFunctions = {
  sigmoid: sigmoid,
  relu: relu
}

export {
  activationFunctions
}